
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class MoreButton extends Vue {
  @Prop({ default: null }) private duplicateFunction!: () => void | null;
  @Prop({ default: null }) private deleteFunction!: () => void | null;
  @Prop({ default: null }) private renameFunction!: () => void | null;
  @Prop({ default: null }) private convertManualFunction!: () => void | null;
  @Prop({ default: null }) private convertAutomatedFunction!: () => void | null;

  get items() {
    const items = [];
    if (this.deleteFunction) {
      items.unshift({
        title: this.$t('global.delete'),
        icon: 'mdi-delete',
        id: 'delete',
        function: this.deleteFunction,
      });
    }
    if (this.duplicateFunction) {
      items.unshift({
        title: this.$t('global.duplicate'),
        icon: 'mdi-content-copy',
        id: 'duplicate',
        function: this.duplicateFunction,
      });
    }
    if (this.renameFunction) {
      items.unshift({
        title: this.$t('global.edit_name'),
        icon: 'mdi-square-edit-outline',
        id: 'edit',
        function: this.renameFunction,
      });
    }
    if (this.convertManualFunction) {
      items.unshift({
        title: this.$t('scheme.dependency.convert_manual'),
        icon: 'mdi-clipboard-check',
        id: 'convert-manual',
        function: this.convertManualFunction,
      });
    }
    if (this.convertAutomatedFunction) {
      items.unshift({
        title: this.$t('scheme.dependency.convert_automated'),
        icon: 'mdi-clipboard-check',
        id: 'convert-automated',
        function: this.convertAutomatedFunction,
      });
    }
    return items;
  }
}
